import type { Api, ApiFilterBuilder } from '@automapa/svelte-automapa-template';
import { z } from 'zod';
import type { QueriesType } from '../components/telematics/types';
import {
    ModifyRequestSchema,
    type ModifyRequestType,
    ModifyResponseSchema,
    type ModifyResponseType,
} from '../components/Location/LocationApi';

export class ApiInterface {
    protected static async _query<RT>(
        api: Api,
        queries: QueriesType,
        filter: ApiFilterBuilder,
        endpoint: string,
        RS: z.Schema
    ): Promise<RT[]> {
        let filterUri = filter.getUri();
        return api.getData<QueriesType, RT[]>(
            'post',
            `/${endpoint}/query${filterUri}`,
            queries,
            z.any(),
            z.array(RS)
        );
    }

    protected static async _getAll<RT>(
        api: Api,
        filter: ApiFilterBuilder,
        endpoint: string,
        RS: z.Schema
    ): Promise<RT[]> {
        let filterUri = filter.getUri();
        return api.getData<undefined, RT[]>(
            'get',
            `/${endpoint}${filterUri}`,
            undefined,
            z.undefined(),
            z.array(RS)
        );
    }

    protected static async _getOne<RT>(
        api: Api,
        id: number,
        endpoint: string,
        RS: z.Schema
    ): Promise<RT> {
        return api.getData<undefined, RT>(
            'get',
            `/${endpoint}/${id}`,
            undefined,
            z.undefined(),
            RS
        );
    }

    protected static async _remove(api: Api, id: number, endpoint: string): Promise<void> {
        return api.delete(`/${endpoint}/${id}`);
    }

    protected static async _updateOne<RequestT, ResponseT>(
        api: Api,
        id: number,
        endpoint: string,
        data: RequestT,
        RequestS: z.Schema,
        ResponseS: z.Schema
    ): Promise<ResponseT> {
        return api.getData<RequestT, ResponseT>(
            'put',
            `/${endpoint}/${id}`,
            data,
            RequestS,
            ResponseS
        );
    }
}
